/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.9881 14.8438c-.3606-.0018-.7209-.0885-1.0442-.26l-3.3867-1.7964-5.4374 2.8845 9.6365 5.1119a.5253.5253 0 0 0 .3933.0385l.0941-.0385 9.6342-5.1119-5.4351-2.8845-3.3867 1.7964c-.3233.1715-.6836.2582-1.0442.26a.9441.9441 0 0 1-.0238 0Zm-.2354 5.9468-.006.0114ZM.3555 16.434c-.3739-.3261-.4715-.8568-.2033-1.286a1.0687 1.0687 0 0 1 .2042-.2386 1.1036 1.1036 0 0 1 .09-.0707l.1248-.0767 5.3543-2.8401-5.3543-2.84a1.1409 1.1409 0 0 1-.2157-.1479c-.3739-.326-.4715-.8568-.2033-1.286a1.0682 1.0682 0 0 1 .2043-.2387 1.138 1.138 0 0 1 .2147-.1473L10.944 1.76c.6538-.3467 1.4584-.3467 2.1122 0l10.3727 5.502c.0813.0431.1547.0941.2197.1513.3706.3264.4665.855.1993 1.2825a1.0673 1.0673 0 0 1-.2003.2353 1.1392 1.1392 0 0 1-.2187.1508l-5.3543 2.84 5.3543 2.8401c.0815.0432.155.0943.22.1516.3703.3264.4661.8547.199 1.2822a1.0698 1.0698 0 0 1-.2003.2353 1.1327 1.1327 0 0 1-.0939.0741l-.1248.0767-10.3727 5.5019c-.5884.3121-1.299.3433-1.9118.0936l-.2004-.0936L.5712 16.5819a1.142 1.142 0 0 1-.2157-.1479Zm11.4008-3.1502a.5243.5243 0 0 0 .4874 0l9.6342-5.1119L12.2437 3.06a.5256.5256 0 0 0-.3933-.0384l-.0941.0384-9.6365 5.112 9.6365 5.1118Z"
    clipRule="evenodd"
  />,
  'Source'
);
